// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-courses-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  background: #0A0A1B;
  color: white;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Page Header */
.page-header {
  text-align: center;
  margin-bottom: 4rem;
  padding: 1rem 0;
  position: relative;
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(123, 61, 216, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 0;
}

.page-header h1 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  letter-spacing: -0.02em;
  animation: fadeInUp 0.8s ease-out;
}

.page-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  font-weight: 400;
  position: relative;
  z-index: 1;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

/* Special gradient for main hero title */
.purple-gradient-text {
  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
}

/* Animation for titles and subtitles */
.animated-title {
  animation: fadeInUp 0.8s ease-out both;
}

.animated-subtitle {
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
}

.loading-spinner {
  margin-bottom: 1.5rem;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top: 3px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error States */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 2rem;
}

.error-message {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: #fca5a5;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.retry-button {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.retry-button:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  max-width: 500px;
  margin: 0 auto;
}


.empty-state h2 {
  font-size: 1.5rem;
  color: white;
  margin: 0 0 0.5rem;
  font-weight: 600;
}

.empty-state p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 1rem;
  margin: 0 0 2rem;
  line-height: 1.6;
}

.add-course-button {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.add-course-button:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.add-course-button span {
  font-size: 1.2rem;
  font-weight: 300;
}

/* Courses Grid - Enhanced Horizontal Layout */
.courses-grid {
  display: flex;
  gap: 1.5rem;
  margin-top: 2rem;
  overflow-x: auto;
  padding: 1rem 0.5rem 1.5rem 0.5rem;
  scroll-behavior: smooth;
}

.courses-grid::-webkit-scrollbar {
  height: 6px;
}

.courses-grid::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
}

.courses-grid::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, #7b3dd8, #5707ab);
  border-radius: 10px;
}

.courses-grid::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(90deg, #7b3dd8, #5707ab);
}

/* Enhanced Course Card */
.course-card {
  background: linear-gradient(145deg, rgba(31, 41, 55, 0.8), rgba(17, 24, 39, 0.9));
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  height: 200px;
  width: 280px;
  flex-shrink: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.course-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(145deg, transparent, rgba(59, 130, 246, 0.05));
  opacity: 0;
  transition: opacity 0.4s ease;
  border-radius: 16px;
  z-index: 1;
}

.course-card:hover {
  transform: translateY(-8px) scale(1.02);
  background: linear-gradient(145deg, rgba(31, 41, 55, 0.95), rgba(17, 24, 39, 1));
  border-color: rgba(59, 130, 246, 0.4);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(59, 130, 246, 0.2);
}

.course-card:hover::before {
  opacity: 1;
}

/* Enhanced Thumbnail */
.course-thumbnail {
  position: relative;
  width: 100%;
  height: 110px;
  overflow: hidden;
  z-index: 2;
}

.course-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  filter: brightness(0.9) contrast(1.1);
}

.course-card:hover .course-thumbnail img {
  transform: scale(1.08);
  filter: brightness(1) contrast(1.2);
}

/* Enhanced Course Info */
.course-info {
  padding: 1rem;
  height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%);
}

.course-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: white;
  margin: 0 0 0.5rem 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 2.8rem;
  transition: color 0.3s ease;
}

.course-card:hover .course-title {
  color: #e0e7ff;
}

.course-meta {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  color: rgba(156, 163, 175, 0.9);
  gap: 0.5rem;
  margin-top: auto;
  font-weight: 500;
}

.video-count {
  color: #60a5fa;
  font-weight: 600;
  background: rgba(96, 165, 250, 0.1);
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  border: 1px solid rgba(96, 165, 250, 0.2);
}

.duration {
  color: #86efac;
  font-weight: 600;
  background: rgba(134, 239, 172, 0.1);
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  border: 1px solid rgba(134, 239, 172, 0.2);
}

.meta-separator {
  display: none;
}

/* Delete Button - Smaller */
.delete-course-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: rgb(248, 113, 113);
  border: none;
  border-radius: 0.375rem;
  padding: 0.375rem;
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s ease;
  z-index: 2;
}

.course-card:hover .delete-course-button {
  opacity: 1;
}

.delete-course-button:hover {
  background-color: rgba(220, 38, 38, 0.2);
  color: rgb(220, 38, 38);
}






/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
  backdrop-filter: blur(5px);
}

.modal-content {
  background: #1a1a2e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  max-width: 400px;
  width: 100%;
  animation: modalSlideIn 0.3s ease-out;
  overflow: hidden;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  padding: 1.5rem 1.5rem 0;
}

.modal-header h3 {
  color: white;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.modal-body {
  padding: 1rem 1.5rem 1.5rem;
}

.modal-body p {
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 0.75rem;
  line-height: 1.5;
}

.course-title-preview {
  color: white;
  font-weight: 600;
  font-style: italic;
}

.warning-text {
  color: #fca5a5;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.modal-actions {
  display: flex;
  gap: 0.75rem;
  padding: 0 1.5rem 1.5rem;
}

.cancel-button {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.cancel-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.confirm-button {
  flex: 1 1;
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.4);
  color: #fca5a5;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.confirm-button:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.3);
  border-color: rgba(239, 68, 68, 0.6);
}

.confirm-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(252, 165, 165, 0.3);
  border-top: 2px solid #fca5a5;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .course-card {
    width: 250px;
  }
}

@media (max-width: 768px) {
  .courses-grid {
    gap: 0.75rem;
  }
  
  .course-card {
    height: 180px;
    width: 220px;
  }
  
  .course-thumbnail {
    height: 100px;
  }
  
  .course-info {
    height: 80px;
    padding: 0.5rem;
  }
  
  .course-title {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .courses-grid {
    gap: 0.5rem;
  }
  
  .course-card {
    height: 160px;
    width: 180px;
  }
  
  .course-thumbnail {
    height: 90px;
  }
  
  .course-info {
    height: 70px;
    padding: 0.5rem;
  }
  
  .course-title {
    font-size: 0.75rem;
    -webkit-line-clamp: 1;
    height: 1.3rem;
  }
  
  .course-meta {
    font-size: 0.7rem;
  }
}

/* Main content structure */
.courses-section {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.content-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.section-title {
  color: white;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  padding-bottom: 1rem;
  position: relative;
  background: linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.02em;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #7b3dd8, #5707ab);
  border-radius: 2px;
} `, "",{"version":3,"sources":["webpack://./src/components/MyCoursesPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,+EAA+E;AACjF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gHAAgH;EAChH,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,yCAAyC;AACzC;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,8CAA8C;EAC9C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;AACtD;;AAEA,yBAAyB;AACzB;EACE,iFAAiF;EACjF,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0EAA0E;EAC1E,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,gFAAgF;EAChF,qCAAqC;EACrC,6EAA6E;AAC/E;;AAEA;EACE,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uDAAuD;EACvD,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,4EAA4E;AAC9E;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;;;;;;AAOA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB","sourcesContent":[".my-courses-page {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: 100vh;\n  background: #0A0A1B;\n  color: white;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* Page Header */\n.page-header {\n  text-align: center;\n  margin-bottom: 4rem;\n  padding: 1rem 0;\n  position: relative;\n}\n\n.page-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(circle, rgba(123, 61, 216, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n  z-index: 0;\n}\n\n.page-header h1 {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: white;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem;\n  letter-spacing: -0.02em;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.page-subtitle {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  font-size: 0.9rem;\n  font-weight: 600;\n  animation: fadeInUp 0.8s ease-out 0.2s both;\n}\n\n/* Special gradient for main hero title */\n.purple-gradient-text {\n  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  display: inline-block;\n}\n\n/* Animation for titles and subtitles */\n.animated-title {\n  animation: fadeInUp 0.8s ease-out both;\n}\n\n.animated-subtitle {\n  animation: fadeInUp 0.8s ease-out 0.2s both;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Loading States */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  text-align: center;\n}\n\n.loading-spinner {\n  margin-bottom: 1.5rem;\n}\n\n.spinner {\n  width: 48px;\n  height: 48px;\n  border: 3px solid rgba(255, 255, 255, 0.1);\n  border-top: 3px solid rgba(255, 255, 255, 0.6);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.loading-text {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 500;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error States */\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  text-align: center;\n  padding: 2rem;\n}\n\n.error-message {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  color: #fca5a5;\n  padding: 1rem 1.5rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n}\n\n.retry-button {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.retry-button:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n\n.empty-state h2 {\n  font-size: 1.5rem;\n  color: white;\n  margin: 0 0 0.5rem;\n  font-weight: 600;\n}\n\n.empty-state p {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 1rem;\n  margin: 0 0 2rem;\n  line-height: 1.6;\n}\n\n.add-course-button {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 1rem 2rem;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.add-course-button:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n.add-course-button span {\n  font-size: 1.2rem;\n  font-weight: 300;\n}\n\n/* Courses Grid - Enhanced Horizontal Layout */\n.courses-grid {\n  display: flex;\n  gap: 1.5rem;\n  margin-top: 2rem;\n  overflow-x: auto;\n  padding: 1rem 0.5rem 1.5rem 0.5rem;\n  scroll-behavior: smooth;\n}\n\n.courses-grid::-webkit-scrollbar {\n  height: 6px;\n}\n\n.courses-grid::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n}\n\n.courses-grid::-webkit-scrollbar-thumb {\n  background: linear-gradient(90deg, #7b3dd8, #5707ab);\n  border-radius: 10px;\n}\n\n.courses-grid::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(90deg, #7b3dd8, #5707ab);\n}\n\n/* Enhanced Course Card */\n.course-card {\n  background: linear-gradient(145deg, rgba(31, 41, 55, 0.8), rgba(17, 24, 39, 0.9));\n  border-radius: 16px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  position: relative;\n  height: 200px;\n  width: 280px;\n  flex-shrink: 0;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.course-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(145deg, transparent, rgba(59, 130, 246, 0.05));\n  opacity: 0;\n  transition: opacity 0.4s ease;\n  border-radius: 16px;\n  z-index: 1;\n}\n\n.course-card:hover {\n  transform: translateY(-8px) scale(1.02);\n  background: linear-gradient(145deg, rgba(31, 41, 55, 0.95), rgba(17, 24, 39, 1));\n  border-color: rgba(59, 130, 246, 0.4);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(59, 130, 246, 0.2);\n}\n\n.course-card:hover::before {\n  opacity: 1;\n}\n\n/* Enhanced Thumbnail */\n.course-thumbnail {\n  position: relative;\n  width: 100%;\n  height: 110px;\n  overflow: hidden;\n  z-index: 2;\n}\n\n.course-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  filter: brightness(0.9) contrast(1.1);\n}\n\n.course-card:hover .course-thumbnail img {\n  transform: scale(1.08);\n  filter: brightness(1) contrast(1.2);\n}\n\n/* Enhanced Course Info */\n.course-info {\n  padding: 1rem;\n  height: 90px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  z-index: 2;\n  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%);\n}\n\n.course-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: white;\n  margin: 0 0 0.5rem 0;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 2.8rem;\n  transition: color 0.3s ease;\n}\n\n.course-card:hover .course-title {\n  color: #e0e7ff;\n}\n\n.course-meta {\n  display: flex;\n  align-items: center;\n  font-size: 0.75rem;\n  color: rgba(156, 163, 175, 0.9);\n  gap: 0.5rem;\n  margin-top: auto;\n  font-weight: 500;\n}\n\n.video-count {\n  color: #60a5fa;\n  font-weight: 600;\n  background: rgba(96, 165, 250, 0.1);\n  padding: 0.2rem 0.4rem;\n  border-radius: 4px;\n  border: 1px solid rgba(96, 165, 250, 0.2);\n}\n\n.duration {\n  color: #86efac;\n  font-weight: 600;\n  background: rgba(134, 239, 172, 0.1);\n  padding: 0.2rem 0.4rem;\n  border-radius: 4px;\n  border: 1px solid rgba(134, 239, 172, 0.2);\n}\n\n.meta-separator {\n  display: none;\n}\n\n/* Delete Button - Smaller */\n.delete-course-button {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: rgb(248, 113, 113);\n  border: none;\n  border-radius: 0.375rem;\n  padding: 0.375rem;\n  cursor: pointer;\n  opacity: 0;\n  transition: all 0.2s ease;\n  z-index: 2;\n}\n\n.course-card:hover .delete-course-button {\n  opacity: 1;\n}\n\n.delete-course-button:hover {\n  background-color: rgba(220, 38, 38, 0.2);\n  color: rgb(220, 38, 38);\n}\n\n\n\n\n\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 2rem;\n  backdrop-filter: blur(5px);\n}\n\n.modal-content {\n  background: #1a1a2e;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  max-width: 400px;\n  width: 100%;\n  animation: modalSlideIn 0.3s ease-out;\n  overflow: hidden;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modal-header {\n  padding: 1.5rem 1.5rem 0;\n}\n\n.modal-header h3 {\n  color: white;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.modal-body {\n  padding: 1rem 1.5rem 1.5rem;\n}\n\n.modal-body p {\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0 0 0.75rem;\n  line-height: 1.5;\n}\n\n.course-title-preview {\n  color: white;\n  font-weight: 600;\n  font-style: italic;\n}\n\n.warning-text {\n  color: #fca5a5;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0 1.5rem 1.5rem;\n}\n\n.cancel-button {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.cancel-button:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.confirm-button {\n  flex: 1;\n  background: rgba(239, 68, 68, 0.2);\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  color: #fca5a5;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.confirm-button:hover:not(:disabled) {\n  background: rgba(239, 68, 68, 0.3);\n  border-color: rgba(239, 68, 68, 0.6);\n}\n\n.confirm-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.button-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(252, 165, 165, 0.3);\n  border-top: 2px solid #fca5a5;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .course-card {\n    width: 250px;\n  }\n}\n\n@media (max-width: 768px) {\n  .courses-grid {\n    gap: 0.75rem;\n  }\n  \n  .course-card {\n    height: 180px;\n    width: 220px;\n  }\n  \n  .course-thumbnail {\n    height: 100px;\n  }\n  \n  .course-info {\n    height: 80px;\n    padding: 0.5rem;\n  }\n  \n  .course-title {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .courses-grid {\n    gap: 0.5rem;\n  }\n  \n  .course-card {\n    height: 160px;\n    width: 180px;\n  }\n  \n  .course-thumbnail {\n    height: 90px;\n  }\n  \n  .course-info {\n    height: 70px;\n    padding: 0.5rem;\n  }\n  \n  .course-title {\n    font-size: 0.75rem;\n    -webkit-line-clamp: 1;\n    height: 1.3rem;\n  }\n  \n  .course-meta {\n    font-size: 0.7rem;\n  }\n}\n\n/* Main content structure */\n.courses-section {\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n}\n\n.content-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.section-title {\n  color: white;\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0;\n  padding-bottom: 1rem;\n  position: relative;\n  background: linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.02em;\n}\n\n.section-title::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 0;\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(90deg, #7b3dd8, #5707ab);\n  border-radius: 2px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
